import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Auth, I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';
import { TERM_VER } from '../../configures/val.js';
import checkTermsVer from '../util/checkTermsVer.js';
import LapDialog from '../util/laplaceDialog.js';
import { Button } from '@material-ui/core';
import Dialog from '../common/Dialog/index.js';
import Pagenation from '../common/Pagenation/index.js';

/** アカウント情報画面で表示できる最大数 */
const maxAccountsOnTop = 10;
/** アカウント情報の詳細ダイアログで表示できる最大数 */
const maxAccountsPerPage = 30;

export default class UserProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      isError: true,
      termVerError: false,
      isAccountInfoDialogOpen: false,
      accountInfoCurrentPage: 0,
    };
  }
  showOrganization = (userProf) => {
    if (!userProf.hasOwnProperty('custom:organization')) return <div />;
    if (userProf.organization === '') return <div />;
    return (
      <div>
        <dt className='mypageUserinfoItemHeader'>
          <Typography variant='subheading' gutterBottom>
            {I18n.get('Company/Institution name')}
          </Typography>
        </dt>
        <dd className='mypageUserinfoItemData'>
          <Typography>{userProf['custom:organization']}</Typography>
        </dd>
      </div>
    );
  };
  checkUser() {
    const that = this;
    return Auth.currentAuthenticatedUser()
      .then((user) => {
        if (!that._isMounted) {
          return;
        }
        Auth.userAttributes(user)
          .then((attrRet) => {
            const isLowVer = checkTermsVer(attrRet, 'custom:agreed_term', TERM_VER, 'ver');
            if (isLowVer) {
              this.setState({
                termVerError: true,
              });
              return;
            }
            // ログイン済みで正しくトークンが生きている
            return;
          })
          .catch((attrErr) => {
            // トークンが死んでいる可能性がある
            Auth.signOut().then(() => this.props.authStateChange('signIn'));
          });
      })
      .catch((err) => {
        if (!that._isMounted) {
          return;
        }
        Auth.signOut().then(() => this.props.authStateChange('signIn'));
      });
  }
  componentDidMount() {
    this._isMounted = true;
    this.checkUser();
    this.props.updateHeader();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  async closeTermVerError(that) {
    const user = await Auth.currentAuthenticatedUser();
    that.props.authStateChange('reagreeTermsDocs', user);
    this.setState({
      termVerError: false,
    });
    return;
  }
  openAccountInfoDialog = () => {
    this.setState({
      isAccountInfoDialogOpen: true,
    });
  };
  closeAccountInfoDialog = () => {
    this.setState({
      isAccountInfoDialogOpen: false,
    });
  };
  setAccountInfoCurrentPage = (page) => {
    this.setState({
      accountInfoCurrentPage: page,
    });
  };
  createAccountInfoDetailsContent = (accounts) => {
    const start = this.state.accountInfoCurrentPage * maxAccountsPerPage;

    return (
      <>
        <dl className='accountInfoDetails'>
          {accounts.slice(start, start + maxAccountsPerPage).map(({ displayName }, index) => (
            <div key={index}>
              <dt>{`${I18n.get('Belonging Account Name')} ${start + ++index}`}</dt>
              <dd>{displayName}</dd>
            </div>
          ))}
        </dl>
        {accounts.length > maxAccountsPerPage && (
          <Pagenation
            totalPages={Math.ceil(accounts.length / maxAccountsPerPage)}
            currentPage={this.state.accountInfoCurrentPage}
            setCurrentPage={this.setAccountInfoCurrentPage}
          />
        )}
      </>
    );
  };
  /**
   * 所属アカウント情報を表示する
   * @param {[]} accounts - 所属アカウント情報
   * @returns {JSX.Element}
   */
  showAccountInfo = (accounts) => {
    return (
      <div>
        <p className='mypageTitle'>
          <span className='mypageTitleIcon'></span>
          {I18n.get('Account Info')}
        </p>
        <dl className='mypageUserinfoItem accountInfo'>
          {accounts.slice(0, maxAccountsOnTop).map(({ displayName }, index) => (
            <div key={index}>
              <dt className='mypageUserinfoItemHeader itemBorder'>
                <Typography variant='subheading' gutterBottom>
                  {`${I18n.get('Belonging Account Name')} ${accounts.length > 1 ? index + 1 : ''}`}
                </Typography>
              </dt>
              <dd className='mypageUserinfoItemData itemBorder'>
                <Typography>{displayName}</Typography>
              </dd>
            </div>
          ))}
        </dl>
        {accounts.length > maxAccountsOnTop && (
          <>
            <div className='showAllAccountsBtnArea'>
              <Button
                color='primary'
                variant='contained'
                size='large'
                onClick={this.openAccountInfoDialog}
              >
                {I18n.get('Show all')}
              </Button>
            </div>
            <Dialog
              open={this.state.isAccountInfoDialogOpen}
              onClose={this.closeAccountInfoDialog}
              title={`${I18n.get('Account Info')} ${I18n.get('Details')}`}
              content={this.createAccountInfoDetailsContent(accounts)}
            />
          </>
        )}
      </div>
    );
  };

  render() {
    const { userProf } = this.props;
    if (userProf) {
      return (
        <div className='mypageContainer'>
          <p className='mypageTitle'>
            <span className='mypageTitleIcon'></span>
            {I18n.get('Sign In Account')}
          </p>
          <dl className='mypageUserinfoItem'>
            <dt className='mypageUserinfoItemHeader itemBorder'>
              <Typography variant='subheading' gutterBottom>
                {I18n.get('Mail')}
              </Typography>
            </dt>
            <dd className='mypageUserinfoItemData itemBorder'>
              {userProf.email}
              <Link className='mypageNormalButton blue' to='/updateaddress'>
                {I18n.get('Edit')}
              </Link>
            </dd>
            <dt className='mypageUserinfoItemHeader itemBorder'>
              <Typography variant='subheading' gutterBottom>
                {I18n.get('Password')}
              </Typography>
            </dt>
            <dd className='mypageUserinfoItemData itemBorder'>
              ●●●●●●●●
              <Link className='mypageNormalButton blue' to='/updatepass'>
                {I18n.get('Edit')}
              </Link>
            </dd>
          </dl>
          <p className='mypageTitle'>
            <span className='mypageTitleIcon'></span>
            {I18n.get('Personal data')}
            <Link className='mypageNormalButton blue' to='/updateprofile'>
              {I18n.get('Edit')}
            </Link>
          </p>
          <dl className='mypageUserinfoItem'>
            <dt className='mypageUserinfoItemHeader'>
              <Typography variant='subheading' gutterBottom>
                {I18n.get('Name')}
              </Typography>
            </dt>
            <dd className='mypageUserinfoItemData'>
              <Typography>
                {userProf.family_name}
                {userProf.given_name}
              </Typography>
            </dd>
            {this.showOrganization(userProf)}
          </dl>
          {this.props.accounts.length > 0 && this.showAccountInfo(this.props.accounts)}
          <LapDialog
            title={''}
            contentElem={
              <div>
                <p>{I18n.get('Terms of Service is updated.')}</p>
                <p>{I18n.get('Please reconfirm it.')}</p>
              </div>
            }
            firstButtonText={'OK'}
            firstButtonFunc={() => this.closeTermVerError(this)}
            open={this.state.termVerError}
            toClose={() => {
              return;
            }}
          />
        </div>
      );
    } else {
      return (
        <div>
          <Typography className='textCenter' variant='subheading' gutterBottom>
            {I18n.get('Please logout, and re-login')}
          </Typography>
        </div>
      );
    }
  }
}
